export const RecordUtils = {
  isEqual,
  createGetDefaultProperty,
  updateImmutableInstace,
};

function isEqual(x: any, y: any): boolean {
  // eslint-disable-next-line no-self-compare
  return x === y || (x !== x && y !== y);
}

function createGetDefaultProperty<T>(defaultProperties: T) {
  function getDefaultProperty<K extends keyof T>(key: K, initializer: Partial<T> | null | undefined): T[K] {
    if (initializer == null || initializer[key] === undefined) return defaultProperties[key];

    return initializer[key]!;
  }

  return getDefaultProperty;
}

function updateImmutableInstace<M extends object, MC extends M, K extends keyof M>(
  Model: new (initializer: M) => MC,
  instance: MC,
  key: K,
  value: M[K],
): MC {
  if (RecordUtils.isEqual(instance[key], value)) return instance;

  const newModel = new Model(instance);
  newModel[key] = value as MC[K];

  return newModel;
}
